import {
  isDtoValidationError,
  isStandardError,
} from '@upstart/harmony/lib/backend-validation-utils';

export interface MFAError {
  error: string;
  status?: string;
}

const GENERIC_LOGIN_ERROR =
  'There was an unexpected error on login. Please try again and contact support if the problem persists.';

export const parseError = (error?: {
  error: unknown;
  status: number;
}): MFAError | null => {
  if (!error) {
    return null;
  }

  try {
    const errorObject = JSON.parse(error.error as string);
    if (isStandardError(errorObject)) {
      return {
        error: errorObject.error,
        status: (errorObject as MFAError).status,
      };
    }

    if (isDtoValidationError(errorObject)) {
      return {
        error: Object.values(errorObject.error).join(' '),
      };
    }

    return {
      error: GENERIC_LOGIN_ERROR,
    };
  } catch (e) {
    if (error.status === 401) {
      return null;
    }

    return {
      error: GENERIC_LOGIN_ERROR,
    };
  }
};
